module.exports = {
	add: require('./add.js'),
	cosSimilarity: require('./cos-similarity'),
	euclideanDist: require('./euclidean-dist'),
	diag: require('./diag.js'),
	diagBlock: require('./diag-block'),
	dotProduct: require('./dot-product'),
	elemWise: require('./elem-wise.js'),
	frobenius: require('./frobenius.js'),
	identity: require('./identity.js'),
	invert: require('./invert.js'),
	mapMatrix: require('./map-matrix.js'),
	matMul: require('./mat-mul.js'),
	matPermutation: require('./mat-permutation.js'),
	padWithZeroCols: require('./pad-with-zero-cols.js'),
	subtract: require('./subtract.js'),
	subSquareMatrix: require('./sub-square-matrix.js'),
	sum: require('./sum.js'),
	trace: require('./trace.js'),
	transpose: require('./transpose.js'),
	zeros: require('./zeros.js'),
	norm: require('./norm.js'),
	sumVector: require('./sum-vector.js'),
};
